import { render, staticRenderFns } from "./addGoodsModal.vue?vue&type=template&id=82959c3e&scoped=true&"
import script from "./addGoodsModal.ts?vue&type=script&lang=ts&"
export * from "./addGoodsModal.ts?vue&type=script&lang=ts&"
import style0 from "./addGoodsModal.vue?vue&type=style&index=0&id=82959c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82959c3e",
  null
  
)

export default component.exports